import {Component} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {IdexService} from '../../idex.service';
import {Toast} from '../../shared/toast/toast';

@Component({
   selector: 'app-allow-client-dialog',
   templateUrl: './allow-client-dialog.component.html',
   styleUrls: ['./allow-client-dialog.component.css']
})
export class AllowClientDialogComponent {
   siteCode: string;
   item: any;
   clientId = '';
   description = '';
   error = '';
   submitting = false;

   constructor(public service: IdexService, public toast: Toast,
               private dialogRef: MatDialogRef<AllowClientDialogComponent>,
               private translate: TranslateService) {
   }

   init(siteCode: string, item?: any) {
      this.siteCode = siteCode;
      if (item) {
         this.item = item;
         this.clientId = item.clientId;
         this.description = item.description || '';
      }
   }

   save() {
      const cid = this.clientId.trim();
      if (!cid) { return; }
      this.submitting = true;
      this.error = '';
      const body = {clientId: cid, description: this.description};
      const req = this.item
         ? this.service.updateAllowedClient(this.siteCode, this.item.id, body)
         : this.service.createAllowedClient(this.siteCode, body);
      req.subscribe(() => {
         this.dialogRef.close(true);
      }, (e: any) => {
         this.submitting = false;
         this.error = this.mapSaveError(e);
      });
   }

   // Translate the duplicate-client error and fall back to the raw message.
   private mapSaveError(e: any): string {
      const msg = (e && e.message) ? e.message : '';
      if (msg.indexOf('already exists') >= 0) {
         return this.translate.instant('company.allow-duplicate-client');
      }
      return msg || 'Save failed';
   }
}
